import GridMatchingRow from 'molecules/grid-matching-row';
import { partnerInterface } from 'constants/interfaces';
import PropTypes from 'prop-types';
import React from 'react';

export default function GridMatchingComponent({ className, country, handleOnClick, partners, partnersRating, t }) {
  return (
    <div className={ `grid-matching-component ${className}` }>
      <div className="grid-matching-component__top">
        <span className="grid-matching-component__top__logo" />
        <span className="grid-matching-component__top__rating">
          { t('Rating') }
        </span>
        <span className="grid-matching-component__top__comments">
          { t('Comments') }
        </span>
        <span className="grid-matching-component__top__price">
          { t('Total price') }
        </span>
        <span className="grid-matching-component__top__extras">
          { t('Extras') }
        </span>
        <span className="grid-matching-component__top__cta">
          <span className="grid-matching-component__top__cta__text">
            { t('Total price') }
          </span>
        </span>
      </div>
      { partners.map((partner, i) => (
        <GridMatchingRow
          key={ i }
          className={ className }
          country={ country }
          handleOnClick={ handleOnClick }
          partner={ partner }
          rating={ partnersRating[partner.id] ? partnersRating[partner.id] : null }
          t={ t }
        />))
      }

      <div className="grid-matching-component__legend">
        { partners.some(p => p.cancellationPolicy && '100' in p.cancellationPolicy)
          ? (
            <span className="grid-matching-component__legend__cancelation hundredicons-cancellation minified full">
              { t('Free cancellation') }
            </span>
          )
          : null
        }
        { partners.some(p => p.cancellationPolicy && !(Object.keys(p.cancellationPolicy).length === 0) && !('100' in p.cancellationPolicy))
          ? (
            <span className="grid-matching-component__legend__cancelation hundredicons-cancellation minified partial">
              { t('Partial Cancellation') }
            </span>
          )
          : null
        }
        { partners.some(p => p.instantlyBooking)
          ? (
            <span className="grid-matching-component__legend__instant-booking hundredicons-instantbook">
              { t('Instant book') }
            </span>
          )
          : null
        }
      </div>
    </div>
  );
}

GridMatchingComponent.defaultProps = {
  className: '',
  country: '',
  partnersRating: {},
};

GridMatchingComponent.propTypes = {
  className: PropTypes.string,
  country: PropTypes.string,
  handleOnClick: PropTypes.func.isRequired,
  partners: PropTypes.arrayOf(partnerInterface).isRequired,
  partnersRating: PropTypes.shape(),
  t: PropTypes.func.isRequired,
};
